module.exports = __webpack_public_path__ + "static/media/7S.1427053b.svg";